"use client";

import { useEffect } from "react";
import type { Testimonial } from "@/lib/testimonials";
import { auditTestimonials } from "./testimonials/shared";
import { Spotlight } from "./testimonials/Spotlight";

/**
 * The reviews section, in the Spotlight design: one review at a time, the person's
 * portrait on the left, the hook and story on the right, a row of faces to switch.
 */
export const Testimonials = ({ testimonials }: { testimonials: Testimonial[] }) => {
  // Development only: check the copy still fits the anatomy
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") auditTestimonials(testimonials);
  }, [testimonials]);

  // Nothing renders until real reviews exist
  if (testimonials.length === 0) return null;

  return <Spotlight testimonials={testimonials} />;
};
